import { GalaxyTableModule, GalaxyDataSource } from '@vendasta/galaxy/table';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Component, Inject, Input, OnChanges, OnInit, SimpleChanges, OnDestroy } from '@angular/core';
import { ClickActivity, ContactTableDataService, ParameterService } from './contact-table.service';
import { GalaxyColumnDef } from '@vendasta/galaxy/table/src/table.interface';
import { MatTableModule } from '@angular/material/table';
import { GalaxyPipesModule } from '@vendasta/galaxy/pipes';
import { DateFormat } from '@vendasta/galaxy/utility/date-utils';
import { BehaviorSubject, combineLatest, Observable, Subscription } from 'rxjs';
import { UsernameCellComponent } from './user-name-cell.component';
import { CommonModule } from '@angular/common';
import { GalaxyEmptyStateModule } from '@vendasta/galaxy/empty-state';
import { MatIconModule } from '@angular/material/icon';
import { EmailEventService } from '@vendasta/email';
import { AttributeInterface } from '@vendasta/email';
import { MatDialog } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { DownloadLinkActivityDialogComponent } from './../link-activity/download-link-activity-dialog/download-link-activity-dialog';
import { SENDER_ID_TOKEN } from '../../../email-activity/src/dependencies';

@Component({
  selector: 'email-contact-table',
  imports: [
    CommonModule,
    TranslateModule,
    GalaxyTableModule,
    GalaxyEmptyStateModule,
    MatIconModule,
    MatTableModule,
    GalaxyPipesModule,
    UsernameCellComponent,
    MatButtonModule,
  ],
  providers: [],
  templateUrl: 'contact-table.component.html',
  styleUrls: ['contact-table.component.scss'],
})
export class ContactTableComponent implements OnInit, OnChanges, OnDestroy {
  dataSource: GalaxyDataSource<ClickActivity>;
  readonly columns: GalaxyColumnDef[] = [
    {
      id: 'name',
      title: this.translateService.instant('CONTACT_TABLE.TABLE_HEADERS.NAME'),
    },
    {
      id: 'email',
      title: this.translateService.instant('CONTACT_TABLE.TABLE_HEADERS.RECIPIENT_EMAIL'),
    },
    {
      id: 'clicks',
      title: this.translateService.instant('CONTACT_TABLE.TABLE_HEADERS.CLICKS'),
    },
    {
      id: 'dateClicked',
      title: this.translateService.instant('CONTACT_TABLE.TABLE_HEADERS.DATE_CLICKED'),
    },
  ];
  readonly dateFormat = DateFormat.medium;

  @Input() attribute: AttributeInterface;
  @Input() eventUrl: string;

  private readonly eventUrl$$: BehaviorSubject<string> = new BehaviorSubject<string>('');
  private subscriptions: Subscription[] = [];

  constructor(
    private readonly translateService: TranslateService,
    @Inject('USER_ID') private userId$: Observable<string>,
    @Inject(SENDER_ID_TOKEN) public senderId$: Observable<string>,
    private emailEventService: EmailEventService,
    private readonly dialog: MatDialog,
  ) {}

  openDownloadDialog(): void {
    this.subscriptions.push(
      combineLatest([this.senderId$, this.userId$]).subscribe(([pid, userId]) => {
        this.dialog.open(DownloadLinkActivityDialogComponent, {
          data: {
            senderId: pid,
            userId: userId,
            normalizedUrl: this.eventUrl,
            attributeValue: this.attribute.value,
            attributeKey: this.attribute.key,
          },
        });
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  ngOnInit(): void {
    this.eventUrl$$.next(this.eventUrl);
    const paramsService = new ParameterService(this.attribute, this.senderId$, this.eventUrl$$.asObservable());
    const service = new ContactTableDataService(paramsService, this.emailEventService);
    this.dataSource = new GalaxyDataSource<ClickActivity>(service);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.eventUrl) {
      this.eventUrl$$.next(changes.eventUrl.currentValue);
    }
  }
}
